import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { OpeningAnnotation, PointoramaAnnotation } from '../../../../potree/utils/PointoramaAnnotation';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];

export function createSyncOpeningsConfig({
  viewer,
  annotations,
  groups,
}: {
  viewer: NonNullable<RendererContextType['viewer']>;
  annotations: Annotation[];
  groups: Project['state']['groups'];
}): SyncConfig<Annotation, OpeningAnnotation> {
  const groupsByIdentifier = Object.fromEntries(groups.map((g) => [g.identifier, g]));

  return {
    getSourceItems: () => annotations.filter((a) => a.type === 'OPENING'),
    getSceneItems: () => viewer.scene.measurements.filter((m): m is OpeningAnnotation => m instanceof OpeningAnnotation && m.finished),
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry + opening_kind updates are handled by reactive subscriptions
    create: (source, existing) => {
      const measure = new OpeningAnnotation({
        viewer,
        finished: true,
        identifier: source.identifier,
        selected: existing?.selected || false,
      });
      measure.groupIdentifier = source.groupIdentifier || null;
      measure.groupName = (source.groupIdentifier && groupsByIdentifier[source.groupIdentifier]?.name) || '';
      return measure;
    },
    addToScene: (item) => viewer.scene.addMeasurement(item),
    removeFromScene: (item) => {
      if (item instanceof PointoramaAnnotation) {
        viewer.scene.removeMeasurement(item);
      }
    },
    afterCreate: (item) => {
      item.loadGeometryProperties();
    },
    chunkSize: 50,
  };
}
